"use strict";
// Janssen custom schema is missing some _core_ fields which
// should be included in it's mapping.
// There are *product* reasons why we cannot add these
// to the Janssen custom schema.
// So when working with custom schema we need to look at these fields
// as well.
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialJanssenMappings = void 0;
exports.specialJanssenMappings = [
    {
        label: "arxiv",
        rcPath: "ext_ids.arxiv",
    },
    {
        label: "notes",
        rcPath: "user_data.notes",
    },
    {
        label: "pmid",
        rcPath: "ext_ids.pmid",
    },
    {
        label: "issn",
        rcPath: "article.issn",
    }
];
